<script setup lang="ts">
import type { IMenuIPlusDesktop, IMenuIPlusMobile } from './interfaces'
import type { SegmentType } from '~/schema/types/generated'

const route = useRoute()
const isSoho = computed(() => {
    return !!route.path.includes('dla-firm')
})

const { sendMenuEvent } = useSendEvent()

const offersMobile: Record<SegmentType, IMenuIPlusMobile[]> = {
    SOHO: [
        {
            title: 'Abonament',
            links: [
                {
                    id: 'ret',
                    title: 'Przedłuż lub zmień umowę',
                    url: '/dla-firm/abonament/przedluz-umowe',
                },
            ],
        },
        {
            title: 'Internet',
            links: [
                {
                    id: 'acq',
                    title: 'Przedłuż lub zmień umowę',
                    url: '/dla-firm/internet-5g/przedluz-umowe',
                },
            ],
        },
    ],
    IND: [
        {
            title: 'Abonament',
            links: [
                {
                    id: 'acq',
                    title: 'Przedłuż lub zmień umowę',
                    url: '/abonament/przedluz-umowe',
                },
                {
                    id: 'fv',
                    title: 'Opłać fakturę',
                    url: 'https://plus.pl/platnosc/',
                },
            ],
        },
        {
            title: 'Internet',
            links: [
                {
                    id: 'acq',
                    title: 'Przedłuż lub zmień umowę',
                    url: '/internet-5g/przedluz-umowe',
                },
                {
                    id: 'fv',
                    title: 'Opłać fakturę',
                    url: 'https://plus.pl/platnosc/',
                },
            ],
        },
        {
            title: 'Na karte',
            links: [
                {
                    id: 'charge',
                    title: 'Doładuj konto',
                    url: '/doladujonline',
                },
                {
                    id: 'codes',
                    title: 'Krótkie kody',
                    url: '/uslugi/krotkie-kody-w-plusie-na-karte',
                },
            ],
        },
    ],
}

const dataMobile = computed<IMenuIPlusMobile[]>(() => {
    return isSoho.value ? offersMobile.SOHO : offersMobile.IND
})

const dataDesktop: IMenuIPlusDesktop[] = [
    {
        id: 'ind',
        text: 'Klient indywidualny',
        isActive: true,
        url: 'https://ssl.plusgsm.pl/ebok-web/basic/landingPage.action',
    },
    {
        id: 'soho',
        text: 'Firma',
        url: 'https://ssl.plusgsm.pl/ebok-web/basic/loginStep1.action?brandId=Postpaid',
    },
    {
        id: 'pro',
        text: 'Prosument',
        url: 'https://ssl.plusgsm.pl/ebok-web/basic/prosumentLandingPage.action',
    },
]
</script>

<template>
    <div class="md:hidden">
        <PlusBlogLpAtomSheet>
            <PlusBlogLpAtomSheetTrigger>Zaloguj</PlusBlogLpAtomSheetTrigger>
            <PlusBlogLpAtomSheetContent class="border-plus-lp-none w-full p-0">
                <PlusBlogLpAtomSheetHeader class="bg-plus-lp-dark-blue px-3 pb-6 pt-[68px] text-plus-lp-white">
                    <h2 class="mb-3 text-[1.75rem] font-bold leading-9">Aplikacja iPlus</h2>
                    <p class="mb-6 font-thin">
                        Sprawdzaj bieżący stan konta, historię połączeń, dokonuj płatności oraz uruchamiaj dodatkowe
                        usługi.
                    </p>
                    <a
                        href="https://iplus.pl"
                        class="flex h-12 items-center justify-center rounded-3xl bg-plus-lp-green-one font-semibold text-plus-lp-dark-blue"
                    >
                        Przejdź do aplikacji iPlus
                    </a>
                </PlusBlogLpAtomSheetHeader>
                <main class="p-4 text-plus-lp-dark-blue">
                    <div
                        v-for="i in dataMobile"
                        :key="i.title"
                        class="mb-3 mt-6 border-b-2 border-plus-lp-green-one"
                    >
                        <h3
                            class="mb-2 text-xs font-bold uppercase"
                            v-html="i.title"
                        />
                        <template
                            v-for="l in i.links"
                            :key="l.title"
                        >
                            <a
                                :href="l.url"
                                class="color-dark-blue mb-3 block text-lg font-semibold underline"
                            >
                                {{ l.title }}
                            </a>
                        </template>
                    </div>
                </main>
            </PlusBlogLpAtomSheetContent>
        </PlusBlogLpAtomSheet>
    </div>
    <div class="hidden h-full md:block">
        <PlusBlogLpAtomPopover>
            <PlusBlogLpAtomPopoverTrigger
                class="focus-visible:outline-focus h-full transition duration-400 hover:text-plus-lp-green-one focus-visible:rounded-[2px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                @click="sendMenuEvent('Zaloguj')"
            >
                Zaloguj
            </PlusBlogLpAtomPopoverTrigger>
            <PlusBlogLpAtomPopoverContent
                tabindex="0"
                class="mt-6 w-auto rounded-2xl p-4"
                align="end"
            >
                <ul class="flex min-w-52 flex-col gap-2">
                    <li
                        v-for="item in dataDesktop"
                        :key="item.id"
                    >
                        <PlusBlogLpAtomButton
                            :to="item.url"
                            :variant="item.isActive ? 'primary' : 'secondary'"
                            class="flex w-full justify-center"
                            @click="sendMenuEvent(`Zaloguj > ${item.text}`, item.url)"
                        >
                            {{ item.text }}
                        </PlusBlogLpAtomButton>
                    </li>
                </ul>
            </PlusBlogLpAtomPopoverContent>
        </PlusBlogLpAtomPopover>
    </div>
</template>
